export default __webpack_public_path__ + "static/media/about.463c7032.jpg";